export enum EnumTpModeloApuracao {
    ValorBruto,
    ValorVendido,
    Lucro
};